import axios from "axios";
import { Message, Loading } from "element-ui";
const qs = require('qs')
// let baseURL = 'go-grid.lititi.com';
// let baseURLObj = {
//   mock:'https://yapi.lititi.com/mock/68',
//   dev:'https://thailand-iot.lititi.com'
// };
// let baseURL = baseURLObj.dev;

// axios.defaults.baseURL = baseURL;
let loading;
const beginLoading = () => {
  loading = Loading.service({
    lock: true,
    text: "Loading"
  });
};
const closeLoading = () => {
  loading.close();
};


export const Axios = axios.create({
  timeout: 10000,
  // responseType: 'json',
  withCredentials: true, // 是否允许带cookie这些
  headers: {
    "Content-Type": "application/x-www-form-urlencoded;charset=utf-8",
    "mgmtType": 1,
  }
});
// 发送
Axios.interceptors.request.use(
  request => {
    // console.log(request,'request');
    if (request.params && request.params.beginIndex) {
      const {beginIndex, pageSize} = request.params
      request.params.beginIndex = beginIndex * pageSize
    }
    if (request.headers['Content-Type'] !== 'application/json' && request.method === 'post') {
      request.data = qs.stringify(request.data);
    }
    // if(request.loading){
    //   beginLoading();
    // }
    request.headers['Language-Type'] = 'en'
    return request;
  }
    // if (request.loading) {
    //   beginLoading();
    // }
  //   if (request.data && typeof request.data == Object) {
  //     for (let key in  request.data) {
  //       if (!request.data[key]) {
  //         delete request.data[key]
  //       }
  //     }
  //   }
  //   if (request.params && typeof request.params == Object) {
  //     for (let key in  request.params) {
  //       if (!request.params[key]) {
  //         delete request.params[key]
  //       }
  //     }
  //   }
  //   if (request.headers['Content-Type'] != 'application/json' && request.method == 'post') {
  //     request.data = qs.stringify(request.data);
  //   }
  //   if (request.params && request.params.beginIndex) {
  //     const {beginIndex, pageSize} = request.params
  //     request.params.beginIndex = beginIndex * pageSize
  //   }
  //   return request;
  // },
  // err => Promise.reject(err)
);
// 响应拦截器
Axios.interceptors.response.use(
  response => {
    if(!response.data.result){
      Message.error(response.data.message);
      //登录失效
      if(response.data.mdata.errorCode === '000') {
        if(location.pathname !== '/managePage/loginPage') {
          location.href = '/managePage/loginPage'
        }
      }
      return Promise.reject(response.data.message);
    }else{
      return Promise.resolve(response.data);
    }
  }
    //** 兼容图片验证码 */
  //   if (typeof response.data == "string") {
  //     return Promise.resolve(response.data);
  //   }
  //   const { result } = response.data;
  //   const mdata = response.data.mdata || {};
  //   // loading && closeLoading();
  //   if (result == 1) {
  //       return Promise.resolve(response.data);
  //   } else if (result == 0 && mdata.errorCode == 0) {
  //     Message.error(response.data.message);
  //     if (location.pathname !== "/leaseholdMgmt/login") {
  //       window.location.href = "/leaseholdMgmt/login";
  //     }
  //   } else if (result == 2) {

  //     this.$message({
  //       showClose: true,
  //       message: response.data.message,
  //       type: "error",
  //       duration: 5000
  //     });
  //   } else {

  //     Message.error(response.data.message);
  //     return Promise.reject(response.data);
  //   }
  // },
  // err => {
  //   Message.error("网络异常，请稍后重试！");
  //   // loading && closeLoading();
  //   return Promise.reject(err);
);
export default Axios;



// WEBPACK FOOTER //
// ./src/utils/ajax.js